<template>
  <div class="exempt-write-verify" v-loading="loading">
    <div class="title">
      {{trueName}}
    </div>
    <div class="title-tips">
      <div class="editor" @click.stop="toggleEditor" v-if="!disabled">{{editorNow | editorNowText}}</div>
      <div class="editor close" @click.stop="closeEditor">{{editorNow | closeNowText}}</div>
    </div>
    <el-form ref="form" label-width="200px">
      <el-form-item label="免笔试申请条件：" v-if="exemptWriteTypeList && exemptWriteTypeList.length">
        <el-radio-group v-model="exemptWriteType" @change="changeExemptWriteType" :disabled="disableNow">
          <template v-for="(item, index) in exemptWriteTypeList">
            <el-radio class="margin-top" v-if="item && item.code && item.name && item.code !== '0'" :label="item.code" :key="index">{{item.name}}</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="exemptWriteImageListTitle" v-if="exemptWriteType && exemptWriteType !== '0'">
        <div class="exempt-write-image-list">
          <multi-upload  v-model="exemptWriteImageList" :limit="-1" title="" :disabled="disableNow" :showInVerify="true" v-if="!disableNow"></multi-upload>
          <div class="image-block" v-for="(item, index) in exemptWriteImageList" :key="index" v-else>
            <el-image :src="item" :preview-src-list="exemptWriteFileList" fit="contain"></el-image>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="exemptWriteImageOneListTitle" v-if="exemptWriteType && exemptWriteType !== '0' && exemptWriteType !== '4'">
        <div class="exempt-write-image-list">
          <multi-upload  v-model="exemptWrite1ImageList" :limit="-1" title="" :disabled="disableNow" :showInVerify="true" v-if="!disableNow"></multi-upload>
          <div class="image-block" v-for="(item, index) in exemptWrite1ImageList" :key="index" v-else>
            <el-image :src="item" :preview-src-list="exemptWriteFileList" fit="contain"></el-image>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="exemptWriteFileTwoPathTitle" v-if="exemptWriteType === '1'">
        <div class="exempt-write-image-list">
          <multi-upload v-model="exemptWrite2ImageList" :limit="-1" title="" :disabled="disableNow" :showInVerify="true" upload-type="pdf" v-if="!disableNow"></multi-upload>
          <div class="image-block" v-for="(item, index) in exemptWrite2ImageList" :key="index" v-else>
            <a :href="item" target="_blank"><i class="el-icon-document text-icon"></i></a>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="审核结果：" v-if="verifyCodeList && verifyCodeList.length && !editorNow">
        <el-radio-group v-model="verifyCode" :disabled="disabled">
          <template v-for="(item, index) in verifyCodeList">
            <el-radio class="margin-top" v-if="item && item.code && item.name" :label="item.code" :key="index">{{item.name}}</el-radio>
          </template>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核失败原因：" v-if="verifyCode === 'fail' && !editorNow">
        <el-input type="textarea" :maxlength="200" :disabled="disabled"
          v-model="noPassReason" placeholder="请输入200字符以内审核失败原因"></el-input>
      </el-form-item>
    </el-form>
    <div class="bottom-box" v-if="!disabled && !editorNow">
      <div class="verify-success" @click.stop="exemptWriteVerifyFunction">提交审核</div>
      <div class="verify-success verify-fail" @click.stop="closePop">关闭</div>
    </div>
  </div>
</template>

<script>
import multiUpload from './multiUpload'
export default {
  name: 'ExemptWriteVerify',
  components: {
    multiUpload
  },
  props: {
    rowData: Object,
    visible: ''
  },
  computed: {
    exemptWriteImageListTitle () {
      if (this.exemptWriteType === '1') {
        return '副高证书照片'
      } else if (this.exemptWriteType === '2') {
        return '硕士毕业证书信息页照片'
      } else if (this.exemptWriteType === '3') {
        return '国考准考证照片'
      } else if (this.exemptWriteType === '4') {
        return '立功受奖证书信息页或专业技术职务资格证书照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteImageOneListTitle () {
      if (this.exemptWriteType === '1') {
        return '最后学历照片'
      } else if (this.exemptWriteType === '2') {
        return '硕士学位证书信息页照片'
      } else if (this.exemptWriteType === '3') {
        return '国考成绩照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteFileTwoPathTitle () {
      if (this.exemptWriteType === '1') {
        return '单位证明'
      } else {
        return '免考材料'
      }
    },
    disableNow () {
      return this.disabled || !this.editorNow
    },
    exemptWriteFileList () {
      return this.exemptWriteImageList.concat(this.exemptWrite1ImageList)
    }
  },
  data () {
    return {
      loading: false,
      trueName: '',
      exemptWriteType: '',
      exemptWriteTypeList: [],
      exemptWriteImageList: [],
      exemptWrite1ImageList: [],
      exemptWrite2ImageList: [],
      verifyCodeList: [{
        code: 'pass',
        name: '审核通过'
      },
      {
        code: 'fail',
        name: '审核不通过'
      }],
      verifyCode: 'pass',
      noPassReason: '',
      editorNow: false,
      disabled: true
    }
  },
  methods: {
    toggleEditor () {
      if (!this.editorNow) {
        this.editorNow = true
      } else {
        // 提交
        this.submitEditor()
      }
    },
    closePop () {
      this.$emit('hidePopoverAndRefresh')
    },
    submitEditor () {
      let imageForm = {}
      if (this.loading) {
        return false
      }
      this.loading = true
      if (!this.rowData || !this.rowData.id) {
        this.loading = false
        this.$message.error('获取学生id失败,请联系管理员')
        return false
      } else if (!this.exemptWriteType) {
        this.loading = false
        this.$message.error('未知的免考类型')
        return false
      } else {
        // 校验图片数量
        if (this.exemptWriteType !== '0' && (!this.exemptWriteImageList || !this.exemptWriteImageList.length)) {
          this.loading = false
          this.$message.error(this.exemptWriteImageListTitle + '缺失')
          return false
        } else if ((this.exemptWriteType === '1' || this.exemptWriteType === '2' || this.exemptWriteType === '3') && (!this.exemptWrite1ImageList || !this.exemptWrite1ImageList.length)) {
          this.loading = false
          this.$message.error(this.exemptWriteImageOneListTitle + '缺失')
          return false
        } else if (this.exemptWriteType === '1' && (!this.exemptWrite2ImageList || !this.exemptWrite2ImageList.length)) {
          this.loading = false
          this.$message.error(this.exemptWriteFileTwoPathTitle + '缺失')
          return false
        }
        imageForm.exemptWriteFilePath = this.exemptWriteImageList && this.exemptWriteImageList.length ? this.exemptWriteImageList.join(',') : ''
        imageForm.exemptWriteFilePath1 = this.exemptWrite1ImageList && this.exemptWrite1ImageList.length ? this.exemptWrite1ImageList.join(',') : ''
        imageForm.exemptWriteFilePath2 = this.exemptWrite2ImageList && this.exemptWrite2ImageList.length ? this.exemptWrite2ImageList.join(',') : ''
      }
      this.$ajax({
        url: `${this.$attrs['extra-params'].url}/updateEnrollData`,
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.rowData.id,
          exemptWriteType: this.exemptWriteType,
          ...imageForm
        })
      }).then((res) => {
        if (res && res.data && res.data.errorCode === 0) {
          this.loading = false
          this.$message.success('免考信息修改成功')
          this.$nextTick(() => {
            this.initData()
          })
        } else {
          let msg = res && res.data && res.data.message ? res.data.message : '免考信息修改失败'
          this.$message.error(msg)
        }
      }).catch(() => {
        this.$message.error('免考信息修改失败')
      }).finally(() => {
        this.loading = false
      })
    },
    exemptWriteVerifyFunction (code) {
      if (this.editorNow) {
        this.$message.error('请先保存或者取消信息修改')
      } else {
        let form = {}
        this.loading = true
        if (!this.rowData || !this.rowData.id) {
          this.loading = false
          this.$message.error('获取学生id失败,请联系管理员')
          return false
        } else if (!this.verifyCode) {
          this.loading = false
          this.$message.error('请选择审核结果')
          return false
        }
        if (this.verifyCode === 'pass') {
          form.verifyCode = '1'
        } else {
          form.verifyCode = '0'
        }
        form.noPassReason = this.noPassReason ? this.noPassReason : ''
        this.$ajax({
          url: `${this.$attrs['extra-params'].url}/update/status`,
          method: 'post',
          data: this.$qs.stringify({
            postIds: this.rowData.id,
            ...form
          })
        }).then((res) => {
          if (res && res.data && res.data.errorCode === 0) {
            this.closePop()
          } else {
            let msg = res && res.data && res.data.message ? res.data.message : '提交审核结果失败'
            this.$message.error(msg)
          }
        }).catch(() => {
          this.$message.error('提交审核结果失败')
        }).finally(() => {
          this.loading = false
        })
      }
    },
    closeEditor () {
      this.editorNow = false
      this.initData()
    },
    changeExemptWriteType (code) {
      this.exemptWriteImageList = []
      this.exemptWrite1ImageList = []
      this.exemptWrite2ImageList = []
    },
    initData () {
      this.editorNow = false
      if (this.loading) {
        return false
      }
      this.loading = true
      if (!this.rowData || !this.rowData.id) {
        this.loading = false
        this.$message.error('获取学生id失败,请联系管理员')
      } else {
        this.$ajax({
          url: `${this.$attrs['extra-params'].url}/queryEnrollData`,
          method: 'post',
          data: this.$qs.stringify({
            studentId: this.rowData.id
          })
        }).then((res) => {
          if (res && res.data && res.data.errorCode === 0) {
            this.disabled = !res.data.canEdit
            this.trueName = res.data.enrollBasicInfo && res.data.enrollBasicInfo.trueName ? res.data.enrollBasicInfo.trueName : ''
            this.exemptWriteType = res.data.enrollBasicInfo && res.data.enrollBasicInfo.exemptWriteType ? res.data.enrollBasicInfo.exemptWriteType : ''
            this.exemptWriteTypeList = res.data.exemptWriteTypeList && res.data.exemptWriteTypeList.length ? res.data.exemptWriteTypeList : []
            if (res.data.enrollBasicInfo && res.data.enrollBasicInfo.flagExemptWriteStatusCode === '0') {
              this.verifyCode = 'fail'
            } else if (res.data.enrollBasicInfo && res.data.enrollBasicInfo.flagExemptWriteStatusCode === '1') {
              this.verifyCode = 'pass'
            } else {
              this.verifyCode = ''
            }
            this.noPassReason = res.data.enrollBasicInfo && res.data.enrollBasicInfo.noPassReason ? res.data.enrollBasicInfo.noPassReason : ''
            this.$nextTick(() => {
              setTimeout(() => {
                if (res.data.enrollBasicInfo && res.data.enrollBasicInfo.exemptWriteFilePath && res.data.enrollBasicInfo.exemptWriteFilePath.length) {
                  this.exemptWriteImageList = res.data.enrollBasicInfo.exemptWriteFilePath.split(',')
                } else {
                  this.exemptWriteImageList = []
                }
                if (res.data.enrollBasicInfo && res.data.enrollBasicInfo.exemptWriteFilePath1 && res.data.enrollBasicInfo.exemptWriteFilePath1.length) {
                  this.exemptWrite1ImageList = res.data.enrollBasicInfo.exemptWriteFilePath1.split(',')
                } else {
                  this.exemptWrite1ImageList = []
                }
                if (res.data.enrollBasicInfo && res.data.enrollBasicInfo.exemptWriteFilePath2 && res.data.enrollBasicInfo.exemptWriteFilePath2.length) {
                  this.exemptWrite2ImageList = res.data.enrollBasicInfo.exemptWriteFilePath2.split(',')
                } else {
                  this.exemptWrite2ImageList = []
                }
              })
            }, 100)
            this.$forceUpdate()
          } else {
            this.$message.error('获取学生id失败,请联系管理员')
          }
        }).catch(() => {
          this.$message.error('获取学生id失败,请联系管理员')
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },
  filters: {
    editorNowText (val) {
      if (val) {
        return '保存资料修改'
      } else {
        return '编辑审核资料'
      }
    },
    closeNowText (val) {
      if (val) {
        return '取消'
      } else {
        return ''
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.initData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exempt-write-verify{
  padding: 20px;
  background: #FFFFFF;
  min-width: 600px;
  position: relative;
  .margin-top{
    margin-top: 1px;
  }
  ::v-deep .el-form-item__label{
    margin-top: 1px;
  }
  .exempt-write-image-list{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    .image-block {
      width: 150px;
      height: 150px;
      margin-right: 8px;
      margin-bottom: 8px;
      .el-image {
        width: 100%;
        height: 100%;
      }
      .text-icon {
        width: 150px;
        line-height: 150px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  .bottom-box{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    .verify-success{
      padding: 10px 0px;
      width: 100px;
      box-sizing: border-box;
      background: rgba(13, 89, 167, 1);
      color: #FFFFFF;
      border-radius: 10px;
      font-size: 12px;
      cursor: pointer;
      text-align: center;
    }
    .verify-fail{
      margin-left: 20px;
    }
  }
  .title {
    font-size: 15px;
    text-align: center;
    padding: 5px;
    height: 30px;
    font-weight: bold;
  }
  .title-tips{
    position: absolute;
    right: 50px;
    display: flex;
    align-items: center;
    top: 25px;
    .editor{
      cursor: pointer;
      text-decoration: underline;
      color: rgb(13, 89, 167);
    }
    .close{
      margin-left: 20px;
    }
  }
}
</style>
